async function calculateVariantDiscount(variant, displayElement){

  function displayLoading() {
    priceBlock.classList.add("tw-invisible")
    loader.classList.remove("tw-hidden");
    loader.classList.add("tw-block");
    // to stop loading after some time
    setTimeout(() => {
        loader.classList.add("tw-hidden");
        loader.classList.remove("tw-block");
        priceBlock.classList.remove("tw-invisible")
    }, 1000);
}

  let compare_at_price = variant.compare_at_price != undefined && variant.compare_at_price > 0 ? variant.compare_at_price : variant.price 

  let parentProductDiv = displayElement.closest('[data-product-id]')
  const dcr = getCookie("discount_code_referrer");
  let discountPercentage = parentProductDiv.querySelector('[data-discount-percentage]')
  let comparePriceElement = parentProductDiv.querySelector('[data-product-price-compare]')

  let discountValue = parentProductDiv.querySelector('[data-discount-value]')
  let priceBlock = parentProductDiv.querySelector('#price-block')
  let loader = parentProductDiv.querySelector('#price_loader')

  displayLoading()
  if ((dcr && window.productData) || (dcr && displayElement)) {
    var coupon_code = dcr.toString();
    var url = `https://phc-checkout-api.digitalsprung.de/checkout/${coupon_code.toLowerCase()}/${variant.product_id ? variant.product_id : window.productData.productId}/${variant.id}?shop=${Shopify.shop}&price=${variant.price}`

    let discount_price
    let discount_amount
    let discount_type
    let discount_total_value

    fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data?.status == 'valid') {
                discount_price = data.checkoutCart.total
                discount_amount = 100 - Math.round(discount_price * 100 / compare_at_price)
                discount_total_value = data.checkoutCart.value
                discount_type = data.checkoutCart.value_type
                compare_at_price = theme.Currency.formatMoney(compare_at_price, theme.settings.moneyFormat);
            }
        })
        .then(() => {
          if(discount_type == "percentage" && discountPercentage){
            discountPercentage.textContent = discount_amount+"%"
            displayElement.textContent = theme.Currency.formatMoney(discount_price, theme.settings.moneyFormat);
          }
          else if(discountValue) {
            discountValue.textContent = discount_total_value.replace('.0', '')+"€"
            displayElement.textContent = theme.Currency.formatMoney(discount_price, theme.settings.moneyFormat);
          }

          let stickyPrice = document.getElementById('sticky-price')
          if(!!stickyPrice){stickyPrice.textContent = theme.Currency.formatMoney(discount_price, theme.settings.moneyFormat);}

          window.dispatchEvent( new CustomEvent('variant-selected', {
            'detail': 
              {
                id: variant.id,
                price_number: variant.price,
                price: displayElement.textContent,
                productId: variant.product_id,
                compare_price: compare_at_price,
                installment: theme.Currency.formatMoney(Math.round(discount_price/12), theme.settings.moneyFormat),
                title: variant.title}}))

          if(compare_at_price == variant.price){
            comparePriceElement.textContent = compare_at_price
          }
        })
  }
}

function fetchHandler(event) {
    displayLoading()
    var input = textInput.value;
    fetch(finalURL)
        .then(response => response.json())
        .then(json => {
            hideLoading()
            textOutput.innerText = json.contents.translated;
        })
}
// creating url format
// we need 
// https://lessonfourapi.tanaypratap.repl.co/translate/yoda.json?text="your input"

function buildURL(inputData) {
    return `${url}?text=${inputData}`;
}

const circleCountDownTimer = () => {
  return {
    timerEnded: false,
    isLoaded: false,
    endDate: null,
    days: '00',
    hours: '00',
    secondsProgressBar: null,
    minutesProgressBar: null,
    hoursProgressBar: null,
    daysProgressBar: null,
    minutes: '00',
    seconds: '00',
    updateTimer() {
      var now = new Date().getTime();
      var distance = this.endDate - now;
      this.days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
      this.daysProgressBar.setPercent(this.days/7)
      this.hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
      this.hoursProgressBar.setPercent(this.hours/24)
      this.minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
      this.minutesProgressBar.setPercent(this.minutes/60)
      this.seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
      this.secondsProgressBar.setPercent(this.seconds/60)
      return distance
    },
    initProgressBar(bar, canvas){
      canvas.webkitImageSmoothingEnabled=true;
      bar.onchange = () => {
        canvas.clearRect( 0 , 0 , 80 , 80 );
          bar.draw();
      };
      bar.draw();
    },
    initialize(endDate) {

      var secondsCtx = document.getElementById("seconds_canvas").getContext( "2d" );
      var minutesCtx = document.getElementById("minutes_canvas").getContext( "2d" );
      var hoursCtx = document.getElementById("hours_canvas").getContext( "2d" );
      var daysCtx = document.getElementById("days_canvas").getContext( "2d" );

      this.secondsProgressBar = new pingpoliCircleProgressBar( secondsCtx , {xPos:35,yPos:35,radius:30,backgroundLineWidth:1,lineWidth:4} );
      this.minutesProgressBar = new pingpoliCircleProgressBar( minutesCtx , {xPos:35,yPos:35,radius:30,backgroundLineWidth:1,lineWidth:4} );
      this.hoursProgressBar = new pingpoliCircleProgressBar( hoursCtx , {xPos:35,yPos:35,radius:30,backgroundLineWidth:1,lineWidth:4} );
      this.daysProgressBar = new pingpoliCircleProgressBar( daysCtx , {xPos:35,yPos:35,radius:30,backgroundLineWidth:1,lineWidth:4} );

      this.initProgressBar(this.secondsProgressBar,secondsCtx)
      this.initProgressBar(this.minutesProgressBar,minutesCtx)
      this.initProgressBar(this.hoursProgressBar,hoursCtx)
      this.initProgressBar(this.daysProgressBar,daysCtx)
      var $this = this
      $this.isLoaded = true
      //endDate = '7/11/2022 12:00:00'
      endDate += " GMT+0200"
      $this.endDate = new Date(endDate).getTime();
      $this.updateTimer()
      var x = setInterval(function () {
        const distance = $this.updateTimer()  
        if (distance < 0) {
          clearInterval(x);
          $this.timerEnded = true
        }
      }, 1000);
    }
  }
}

const countDownTimer = () => {
  return {
    timerEnded: false,
    isLoaded: false,
    endDate: null,
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
    updateTimer() {
      var now = new Date().getTime();
      var distance = this.endDate - now;
      this.days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
      this.hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
      this.minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
      this.seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
      return distance
    },
    initialize(endDate) {
      var $this = this
      $this.isLoaded = true
      //endDate = '7/11/2022 12:00:00'
      endDate += " GMT+0200"
      $this.endDate = new Date(endDate).getTime();
      $this.updateTimer()
      var x = setInterval(function () {
        const distance = $this.updateTimer()  
        if (distance < 0) {
          clearInterval(x);
          $this.timerEnded = true
        }
      }, 1000);
    }
  }
}


const setCookie = (name, value, days = 7, path = '/') => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

const deleteCookie = (name, path) => {
  setCookie(name, '', -1, path)
}


const productData = () => ({
  product: null,
  variants: [],
  selectedVariant: null,
  quantity: 1,
  decreaseQuantity() {
    this.quantity -= 1
    if (this.quantity <= 1) {
      this.quantity = 1
    }
    window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
  },
  increaseQuantity() {
    this.quantity = this.quantity + 1
    window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
  },
  productImage() {

  },
  selectVariant(id) {
    if (id) {
      this.selectedVariant = this.product.variants.find(item => item.id == id)
      window.dispatchEvent( new CustomEvent('variant-selected', {'detail': {id: this.selectedVariant.id}}))
    }
  },
  initialize(product, variantId) {
    this.product = product
    if (product) {
      this.variants = product.variants
      this.selectedVariant = product.variants.find(item => item.id == variantId)
    }
  }
}); 

const menuDrawer = () => ({
  open: false,
  init() {
    var body = document.querySelector('body');
    this.$watch('open', value => {
      if (body) {
        if (value) {
          body.classList.add("overflow-hidden")
        } else {
          body.classList.remove("overflow-hidden")
        }
      }
    })
  }
});

const interactiveImage = () => {
  return {
    action: null,
    selectedVariantId: null,
    variants: null,
    performEvent() {
      console.log(this.action, this.variants)
      if (this.action == "atc") {
        const items = [];
        const variantsSplit = this.variants.split(",");
        for (let variant of variantsSplit) {
          variant = variant.trim();
          if (variant == 'current') {
            items.push({
              id: parseInt(this.selectedVariantId),
              quantity: 1
            });
          } else {
            items.push({
              id: parseInt(variant),
              quantity: 1
            });
          }
        }
        if (items.length > 0) {
          CartJS.addItems(items);
        }
      }
    },
    initialize(data) {
      this.action = data.action
      this.selectedVariantId = data.selectedVariant
      this.variants = data.variants
    }
  }
};


var EasyCart = (function (module) {
  
  const hooks = [];
  let registerHook;
  let callHook;

  registerHook = function (name, callback) {
    if (typeof hooks[name] === 'undefined') {
      hooks[name] = [];
    }
    hooks[name].push(callback);
  };

  hasRegisteredHook = function (name, callback) {
    if (typeof hooks[name] !== 'undefined') return true;
    return false;
  }; 

  callHook = function (name, args) {
    // console.log("callHook", name, args);
    if (typeof hooks[name] !== 'undefined')
      for (let i = 0; i < hooks[name].length; ++i)
        if (hooks[name][i](args) != true) {
          break;
        }
  };

  module = {
    registerHook,
    callHook,
    debugMode: false
  };

  return module;
})(EasyCart || {}); 


if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

// POST to cart/update.js returns the cart in JSON
ShopifyAPI.updateCart = function (cartUpdates, callback) {
  console.log("ShopifyAPI.updateCart", cartUpdates);
  const items = CartJS.cart.items;

  const keys = Object.keys(cartUpdates);
  const cartJSUpdates = [];
  // console.log(cartUpdates);
  let updated = false;
  const add = [];
  for (var i = 0; i < keys.length; i++) {
    let found = false;

    const id = parseInt(keys[i]);
    const quantity = parseInt(cartUpdates[id]);
    const timer = 1000;

    for (let j = 0; j < items.length; j++) {
      if (items[j].id == id) {
        found = true;
      }
      if (items[j].id == id && items[j].quantity != quantity && !updated) {
        // console.log("updateItem", items, j + 1, quantity);
        CartJS.updateItem(j + 1, quantity);
        updated = true;
      }
    }

    if (!found) {
      add.push({
        id,
        quantity,
      });
    }
  }

  for (var i = 0; i < add.length; i++) {
    CartJS.addItem(add[i].id, add[i].quantity);
  }
};

const newCartDrawer = () => {
  return { 
    cart: null,
    total_price: 0,
    total_price_after_discount: 0,
    total_price_without_discount: 0,
    upsells: [],
    upsellsAvailable: false,
    discount: 0,
    itemsPaid: [], 
    allPaidItems: [],
    itemsFree: [], 
    discountCodeInput: null, 
    validDiscountCode: null,
    codeStatus: null,
    discountedTotal: null,
    open: false,
    firstTimeOpened: false,
    shippingCost: 499,
    loading: false,
    discountLoading: false,
    items: [],
    choiceOverlay: false,
    //Section Cart Gifts
    freeShipping: {
      type: "",
      free_from: 0,
      text: "",
      text_reached: ""
    },
    gifts: [],
    selectedGifts: [],
    alert: false,
    giftSelectionSuccessful: false,
    selectedFreeVariants: [],
    nextGift: null,
    //End Cart Gifts
    sortGiftsBy(prop) {    
      return function(a, b) {    
          if (a[prop] > b[prop]) {    
              return 1;    
          } else if (a[prop] < b[prop]) {    
              return -1;    
          }    
          return 0;    
      }    
    },
    giftAlreadyClaimed(giftProduct){
      return this.items.find(s => s.product_id == giftProduct.id)
    },
    isSelectableGift(item) {
      for(gift of this.gifts){
        if(gift.max != undefined && gift.products.find(product => product.id == item.product_id)){
          return true
        }
      }
      return false
    },
    widthShippingBar() {
      let total = this.total_price_without_discount - this.discount
      const freeShippingFrom = this.freeShipping.free_from * 100
      if(total >= freeShippingFrom)
      {
        return 100
      }
      return Math.abs(total / freeShippingFrom * 100)
    },
    calculateTotalPriceWithoutDiscount(){
      this.total_price_without_discount = this.itemsPaid.map(item => parseInt(item.properties._original_price > item.price ? item.properties._original_price : item.price)*item.quantity).reduce((a,b) => a + b, 0)
    },
    giftsAlreadySelected(blockId){
      for(let gift of this.gifts)
      {
        if(gift.id == blockId)
        {
          let giftsInCart = 0
          for (const item of this.items) {
            const f = gift.products.find(s => s.variants[0].id == item.variant_id)
            if(f){giftsInCart++}
          }
          return giftsInCart >= gift.max
        }
      }
      return false
    },
    freeShippingAfter(money_format){
      return this.total_price_after_discount > (this.freeShipping.free_from * 100) ? this.freeShipping.text_reached : this.giftDiff(money_format, this.freeShipping, null)
    },
    giftDiff(format, gift, nextGift) {
      let total = this.total_price - this.discount
      const diff = (gift.free_from*100) - total
      const nextGiftDiff = (nextGift?.free_from*100) - total;
      const t = gift.text.replace("[money]", Shopify.formatMoney(diff, format))
      return t.includes('[next_money]') ? t.replace("[next_money]", Shopify.formatMoney(nextGiftDiff, format)) : t
    },
    addGiftProduct(giftProduct) {
      if (typeof ga !== 'undefined') {
        ga('send', 'event', "Cart", "CartUpsell");
      }
      CartJS.addItem(giftProduct.id, 1, {}, {
        "error": function(jqXHR, textStatus, errorThrown) {
        }
      });
    },
    hasFreeShipping() {
      const diff = (this.freeShipping.free_from*100) - (this.total_price - this.discount)
      if (diff < 0) {
        this.shippingCost = 0
        return true
      }
      else{
      this.shippingCost = 499
      return false;
      }
    },
    checkMandatories(mandatoryProducts){
      if(mandatoryProducts == undefined){
        return true
      }
      let foundCount = 0
      let notFound = []
      for(product of mandatoryProducts){
        if(!this.items.find(s => s.product_id == product.id)){
          notFound.push(product)
        }
      }
      return notFound
    },
    confirmGiftChoice(item, variantId) {
        let gift = this.nextGift
        this.giftSelectionSuccessful = true;
        let variant_id = variantId ? variantId : item.variants[0].id
        const missingProducts = this.checkMandatories(this.nextGift.mandatory_products)
        let mandatoryAmountFulfilled = false
        if(gift.mandatory_amount == 'one'){
          mandatoryAmountFulfilled = missingProducts.length <= gift.mandatory_products.length -1
        }
        else {
          mandatoryAmountFulfilled = missingProducts.length == 0
        }
        this.alert = false
        if(mandatoryAmountFulfilled){
        // Add gifts that are not added yet
          let alreadyInCart = false
          const f = this.items.find(item => item.variant_id == variant_id)
  
          if (f) alreadyInCart = true;
  
          if (!alreadyInCart) {
            CartJS.addItem(variant_id, 1)
          }
      }
      else{
        this.alert = 'Füge ' + missingProducts.map(s => "<a @click='alert = false' href=/products/"+s.handle+">"+s.title+"</a>").join(', ') + ' hinzu um das Geschenk zu erhalten'
      }
    },
    changeGift(item) {
      const i = this.items.findIndex(s => s.id == item.id)
      if (i > -1) CartJS.removeItem(i + 1)
      this.selectedFreeVariants = this.selectedFreeVariants.filter(s => s != item.variant_id)
      this.setGiftToUnfulfilled(item)
    },
    removeGift(item) {
      const i = this.items.findIndex(s => s.product_id == item.id)
      if (i > -1) CartJS.removeItem(i + 1)
    },
    setGiftToUnfulfilled(item){
      for(gift of this.gifts){
        if(gift.products.find(product => product.id == item.product_id)){
          gift.fulfilled = false
          return
        }
      }
    },
    toggleFreeProduct(product) {
      if (!product.available) {
        return;
      }
  
      const variant = product.variants[0].id
      if (this.selectedFreeVariants.indexOf(variant) == -1) {
        this.selectedFreeVariants.push(variant)
      } else {
        const index = this.selectedFreeVariants.indexOf(variant);
        if (index > -1) {
          //console.log("remove ", variant)
          this.selectedFreeVariants.splice(index, 1);
        }
      }
      if (this.selectedFreeVariants.length > this.maxFreeProducts) {
        this.selectedFreeVariants.splice(0, 1);
      }
    },
    isFreeProductSelected(product) {
      const f = this.selectedFreeVariants.find(v => v.toString() == product.variants[0].id.toString());
      return !!f;
    },
    loadImages() {
      for (const product of this.freeSelectableProducts) {
        fetch(`/search?view=id&type=product&q=${encodeURI('id:' + product.productId)}`)
          .then(response => response.json())
          .then(response => {
            if (response.products && response.products.length > 0) {
              if (response.products[0].title) {
                product.title = response.products[0].title;
              }
              product.image = response.products[0].featured_image;
              product.product_worth = response.products[0].product_worth;
              product.available = !!response.products[0].available;
            }
          }).catch(err => {
          })
      }
    },
    checkFreeItem(item){
      if(item.title.startsWith("(BELOHNUNG)")){
        return
      }
      let foundInGifts = this.gifts.find(gift => gift.products.find(product => product.id == item.product_id))
      if(!foundInGifts){
        CartJS.removeItemById(item.variant_id)
      }
    },
    updateCart(cart) {
      if (cart) {
        var discountCodeCookie = getCookie('discount_code');
        if (discountCodeCookie && !this.discountCodeInput) {
          this.discountCodeInput = discountCodeCookie;
        }
        this.cart = cart
        this.total_price = cart.total_price
        this.items = cart.items
        this.itemsPaid = cart.items.filter(item => item.price > 0)
        this.itemsFree = cart.items.filter(item => item.price == 0)
        this.itemsFree.forEach(item => this.checkFreeItem(item)) 
        const $this = this
  
        setTimeout(() => {
          $this.loading = false
        }, 300)
        if($this.validDiscountCode){
          $this.triggerCheckout($this.validDiscountCode)
        }
        else if(this.discountCodeInput){
          $this.triggerCheckout($this.discountCodeInput)
        }
  
        this.calculateTotalPriceWithoutDiscount(); 
        if(!$this.validDiscountCode){
          this.total_price_after_discount = this.total_price - this.discount
  
          this.checkGiftClaims()
          this.checkUpsells()
        }
  
        this.shippingCost = this.total_price - this.discount > (this.freeShipping.free_from * 100) ? 0 : 499
      }
    },
    checkUpsells(){
      for(upsell of this.upsells){
        for(product of upsell.upsell_products){
          if(this.upsellEligible(product, upsell.mandatory_products))
          {
            this.upsellsAvailable = true
            return
          }
        }
      }
      this.upsellsAvailable = false
    },
    checkAutomaticGifts(gift){
      const missingRequiredProducts = this.checkMandatories(gift.mandatory_products)
      let mandatoryAmountFulfilled = false
      if(gift.mandatory_amount == 'one'){
        mandatoryAmountFulfilled = missingRequiredProducts.length <= gift.mandatory_products.length -1
      }
      else {
        mandatoryAmountFulfilled = missingRequiredProducts.length == 0
      }
      //check if requiredProducts are in cart
      if(this.total_price_after_discount > (gift.free_from*100) && mandatoryAmountFulfilled){
        for(let product of gift.products){
          const index = this.items.findIndex(item => item.product_id == product.id)
          if(index == -1){
            this.addGiftProduct(product.variants[0])
          }
        }
        gift.fulfilled = true
      }
      else {
        gift.fulfilled = false
        for(product of gift.products){
          const index = this.items.findIndex(s => s.product_id == product.id)
          if(index > -1){
            this.removeGift(product)
            return true
          }
          if((this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) || this.nextGift == null || this.nextGift.fulfilled){
            this.nextGift = gift
          //CartJS.removeItem(index +1)
          }
        }
      }
    },
    checkSelectedGifts(gift){
      const missingProductsInCart = this.checkMandatories(gift.mandatory_products)
      let mandatoryAmountFulfilled = false
      if(gift.mandatory_amount == 'one'){
        mandatoryAmountFulfilled = missingProductsInCart.length <= gift.mandatory_products.length -1
      }
      else {
        mandatoryAmountFulfilled = missingProductsInCart.length == 0
      }
  
      if((this.total_price_after_discount < (gift.free_from*100))) {
        gift.variantPickable = mandatoryAmountFulfilled
  
        for(product of gift.products){
          const index = this.items.findIndex(s => s.product_id == product.id)
          if(index > -1){
              this.removeGift(product)
              gift.fulfilled = false
              return true
          }
          if((this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) || this.nextGift == null){
            this.nextGift = gift
          }
          //CartJS.removeItem(index +1)
        }
      }
      else if(!mandatoryAmountFulfilled){
        for(product of gift.products){
          const index = this.items.findIndex(s => s.product_id == product.id)
          if((this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) || this.nextGift == null){
            this.nextGift = gift
          }
          if(index > -1 || !mandatoryAmountFulfilled){
            this.removeGift(product)
            gift.fulfilled = false
            return true
          }
          return false
        }
      } 
      else {
        if((this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) || this.nextGift == null){
          if(!gift.fulfilled){
            this.nextGift = gift
          }
        }
      }
      
      if(this.allGiftsInCart(gift) && mandatoryAmountFulfilled){
        gift.fulfilled = true
        if(this.nextGift == gift){
          this.nextGift = null
        }
        return false
      }
    },
    allGiftsInCart(gift){
      let found = 0
      for(product of gift.products){
        const index = this.items.findIndex(s => s.product_id == product.id)
        if(index > -1){
          found++
        }
      }
      return found==gift.max
    },
    upsellEligible(item, mandatoryProducts){
      let found = false
      const index = this.items.findIndex(s => s.product_id == item.id)
      if(index > -1){
        found = true
      }
      let missingProducts = this.checkMandatories(mandatoryProducts)
      return !found && (missingProducts.length < mandatoryProducts.length)
    },
    checkGiftClaims(){
      let checked = false
        for(gift of this.gifts){
          if(gift.max != undefined){
            checked = this.checkSelectedGifts(gift)
            if (checked) return
          }
          else{
            checked = this.checkAutomaticGifts(gift)
            if (checked) return
          }
        }
    },
    applyDiscountCode() {
      var $this = this;
      if (this.discountCodeInput && this.cart && this.items.length > 0) {
        this.discountLoading = true;
        
        let code = this.discountCodeInput;
        code = code.trim().toLowerCase();
        if (code && code.indexOf('?') > -1) {
          const codeSplit = code.split("?");
          code = codeSplit[0];
        }
  
        let shop = Shopify.shop;
        const data = { cart: JSON.parse(JSON.stringify(this.cart)), code: code, shop: shop };
        fetch('https://secretbrands-checkout-api.digitalsprung.de/checkout', {
          method: 'POST', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(data => {
          setTimeout(() => {
            $this.discountLoading = false
          }, 100)
          
          if (data.checkoutCart) {
            $this.discount = data.checkoutCart.discount
            $this.total_price = data.checkoutCart.subtotal
            $this.total_price_after_discount = data.checkoutCart.total
          } else {
            $this.discount = 0
            $this.total_price = $this.cart.total_price
            $this.total_price_after_discount = $this.cart.total_price
          }
          if (data.status) {
            $this.codeStatus = data.status
          }
          if (data.checkoutCart && data.checkoutCart.discount == 0) {
            $this.codeStatus = 'invalid';
          }
          if ($this.codeStatus == 'valid') {
            $this.validDiscountCode = code.trim().toUpperCase()
            $this.discountCodeInput = code.trim().toUpperCase()
            setCookie("discount_code", code.trim().toUpperCase(), 1);
            setCookie("discount_code_referrer", code.trim().toUpperCase(), 1);
  
            var vdc = document.getElementById("cartDiscountCode");
            vdc && (vdc.value = code.trim().toUpperCase());
  
            var vd = document.getElementById("cartDiscount");
            vd && (vd.value = code.trim().toUpperCase());
  
            setTimeout(() => {
              var cartItems = CartJS.cart.items;
              var items = [];
              let price = 0;
              for (var i = 0; i < cartItems.length; i++) {
                items.push({
                  variant: cartItems[i].variant_id,
                  price: cartItems[i].price,
                  quantity: cartItems[i].quantity
                })
                price += cartItems[i].price;
              }
              if (price == 0) {
                CartJS.clear();
              } else {
                if (typeof EasyCart !== "undefined") {
                  EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
                }
              }
            }, 500);
          } else {
            $this.validDiscountCode = null
          }
        })
      }
    },
    decreaseQuantity(item) {
      this.loading = true
      const index = this.items.findIndex(cartItem => cartItem.id == item.id)
      CartJS.updateItem(index + 1, item.quantity - 1);
    },
    removeItem(item) {
      CartJS.updateItem(index + 1, item);
    },
    increaseQuantity(item) {
      this.loading = true
      const index = this.items.findIndex(cartItem => cartItem.id == item.id)
      CartJS.updateItem(index + 1, item.quantity + 1);
    },
    removeItem(item) {
      this.loading = true
      const index = this.items.findIndex(cartItem => cartItem.id == item.id)
      CartJS.removeItem(index + 1);
    },
    initialize(cart, freeShipping, gifts, upsells) {
      console.log("initialize");
      var $this = this
      console.log(freeShipping);
      $this.freeShipping = freeShipping
      $this.gifts = gifts
      $this.upsells = upsells

      this.$watch('open', value => {
        if (value && !$this.firstTimeOpened) {
          $this.firstTimeOpened = true
        }
        var body = document.querySelector('body');
        if (body) {
          if (value) {
            body.classList.add("overflow-hidden")
          } else {
            body.classList.remove("overflow-hidden")
          }
        }
      });
  
      this.gifts = this.gifts.sort(this.sortGiftsBy("free_from"), "desc")
      if (!cart) return
      this.updateCart(cart)
    },
    calculateSavings(){
      const comparePrices = this.itemsPaid.map(item => parseInt(item.properties?._original_price > item.price ? item.properties._original_price : item.price) * item.quantity).reduce((a,b) => a + b, 0)
      const realPrices = this.total_price - this.discount
      return comparePrices-realPrices
    },
    triggerCheckout(code){
      const $this = this;
      let discountTotal = null
      let checkoutVariants = this.itemsPaid.map(paidItem => {
          return {
            "variant_id": paidItem.variant_id,
            "id": paidItem.variant_id,
            "quantity": paidItem.quantity,
            "properties": {},
            "final_line_price": paidItem.final_line_price
          }
      })
      let payload = {
        "checkout": {
          "country": "DE",
          "discount_code": code,
          "gift_cards": [],
          "line_items": checkoutVariants,
          "presentment_currency": "EUR"
        }
      }
  
      function request() {
        return new Promise(function (resolve, reject) {
          const req = new XMLHttpRequest();
          req.open("POST", "https://"+window.location.host+"/wallets/checkouts/");
          req.onreadystatechange = () => { // Call a function when the state changes.
          }
          const checkoutApiToken = document.querySelector("meta[name='shopify-checkout-api-token']").getAttribute("content")
          req.setRequestHeader('Content-Type', 'application/json');
          req.setRequestHeader("Authorization", "Basic " +btoa(checkoutApiToken));
          req.onload = resolve
          req.onerror = reject
          req.send(JSON.stringify(payload));
        });
      }
  
      request().then(function (e){
        const responseCheckout = JSON.parse(e.target.response)
        const checkout = responseCheckout.checkout

        console.log("checkout", checkout)
        if(checkout != undefined && checkout.discount_code && checkout.discount_code?.toUpperCase() == code.toUpperCase()){
          $this.discount = ($this.total_price) - (parseFloat(checkout.total_price)*100)
          $this.validDiscountCode = code
          var vdc = document.getElementById("cartDiscountCode");
          vdc && (vdc.value = code.trim().toUpperCase());
  
          var vd = document.getElementById("cartDiscount");
          vd && (vd.value = code.trim().toUpperCase());
          $this.codeStatus = 'valid'
          if(checkout.applied_discount.value_type == 'shipping'){
            $this.discount = 0
            $this.shippingCost = $this.shippingCost - ($this.shippingCost * parseFloat(checkout.applied_discount.value)/100)
          }
          else{
            $this.hasFreeShipping()
          }
          setCookie("discount_code", code.trim().toUpperCase(), 1);
          setCookie("discount_code_referrer", code.trim().toUpperCase(), 1);
        } else{
          $this.codeStatus = 'invalid'
          $this.discount = 0
          document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "discount_code_referrer=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          let discountMessage = document.getElementById('discountMessage')
          if(discountMessage){discountMessage.remove()}
          $this.validDiscountCode = code
          var vdc = document.getElementById("cartDiscountCode");
          vdc && (vdc.value = '');
  
          var vd = document.getElementById("cartDiscount");
          vd && (vd.value = '');
        }
        $this.total_price_after_discount = $this.total_price - $this.discount
  
        $this.checkGiftClaims()
        $this.checkUpsells()
      })
    }
  }
};




function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

// const discountCodeInfo = () => {
//   return {
//     show: false,
//     text: null,
//     initialize(textTemplate) {
//       const cc = getCookie("discount_code");
//       var query = window.location.search.substring(1);
//       var qs = parse_query_string(query)

//       if (cc) {
//         let coupon_code = cc.toString();
//         coupon_code = coupon_code.split('&')[0];
    
//         if (qs.discount_note !== undefined && coupon_code != "") {
//           this.text = textTemplate.replace('[discount_code]', coupon_code.toUpperCase())
//           this.show = true
//           if (window.discountCodeCalculation) {
//             setCookie("discount_code_referrer", coupon_code.toUpperCase(), 1);
//           }
//         }
//       }
//     }
//   }
// }

const videoPreloader = () => {
  return {
    load: false,
    url: null,
    id: null,
    startLoading() {
      this.load = true;
      document.addEventListener("pageshow", function(event) {
        const video = document.getElementById(`video-${id}`);
        if (video) {
          if(video.muted) {
            video.muted = false;
          } else {
            video.muted = true;
            video.play()
          }
        }
      });
    },
    initialize(id, url) {
      this.id = id;
      this.url = url;
    }
  }
}

const stickyCartForm = () => {
  return {
    selectedVariant: null,
    quantity: 1,
    decreaseQuantity() {
      this.quantity -= 1
      if (this.quantity <= 1) {
        this.quantity = 1
      }
      window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
    },
    increaseQuantity() {
      this.quantity = this.quantity + 1
      window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
    },
    initialize(variantId) {
      this.selectedVariant = variantId
    }
  }
}